import React from "react";
import styles from "../Demographics.module.css";
import * as d3 from "d3";

const chicagoRace = {
  white: 32.8,
  hispanic: 29.0,
  black: 29.7,
  asian: 6.4,
  other: 2.1,
};

const formatNum = (x) => Number.parseFloat(x).toFixed(1);

const Race = ({ data, hr_race, setHighestRace }) => {
  const raceData = Array.from(
    d3.rollup(
      data,
      (v) => {
        return {
          total: v.length,
          homicidePct: formatNum((v.length / data.length) * 100),
          cityPct: chicagoRace[v[0].raceethnicity.toLowerCase().trim()],
        };
      },
      (d) => d.raceethnicity.toLowerCase().trim()
    )
  );

  const highestPct = d3.max(raceData, (d) => +d[1].homicidePct);
  const highest_homicie_rate_race = raceData.filter(
    (d) => +d[1].homicidePct === highestPct
  )[0];

  // if (!hr_race.name) {
  //   setHighestRace({
  //     name: highest_homicie_rate_race[0],
  //     pct: highest_homicie_rate_race[1].homicidePct,
  //     pop: highest_homicie_rate_race[1].cityPct,
  //   });
  // }

  return (
    <table>
      <thead>
        <tr>
          <th>Race</th>
          <th>Total Homicides</th>
          <th>Pct. of homicides</th>
          <th>Pct. of population</th>
        </tr>
      </thead>
      <tbody>
        {raceData
          .sort((a, b) => (+a[1].homicidePct < +b[1].homicidePct ? 1 : -1))
          .map((d) => {
            let homicideHighlight;
            let demographicHighlight;
            if (d[1].cityPct) {
              +d[1].homicidePct > +d[1].cityPct
                ? (homicideHighlight = styles.Highlight)
                : (demographicHighlight = styles.Highlight);
            }
            return (
              <tr key={d[0]}>
                <td>{d[0]}</td>
                <td>{d[1].total}</td>
                <td className={[homicideHighlight, styles.Num].join(" ")}>
                  {d[1].homicidePct}%
                </td>
                <td className={[demographicHighlight, styles.Num].join(" ")}>
                  {d[1].cityPct ? d[1].cityPct + "%" : "N/A"}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default Race;
